import React from 'react';
import PropTypes from 'prop-types';
import ModalTrigger from '../common/ModalTrigger';
import ProjectSummary from '../common/ProjectSummary';
import './ProjectNameSummaryModal.scss';

function ProjectNameSummaryModal({
  projectName,
  workCommitment,
  location,
  areaOfExpertises,
  tags,
  jobTitles,
  description,
  responsibilities,
  duration,
  workLocation,
  shortOfficeLocation,
  startDate,
  buttonStyles,
}) {
  return (
    <ModalTrigger
      triggerText={projectName}
      triggerType="link"
      buttonStyles={buttonStyles}
      idKey="project-details-invoice"
      dialogClassName="modal-900w"
    >
      <ProjectSummary
        name={projectName}
        workCommitment={workCommitment}
        location={location}
        areaOfExpertises={areaOfExpertises}
        tags={tags}
        jobTitles={jobTitles}
        description={description}
        responsibilities={responsibilities}
        duration={duration}
        workLocation={workLocation}
        shortOfficeLocation={shortOfficeLocation}
        startDate={startDate}
      />
    </ModalTrigger>
  );
}

ProjectNameSummaryModal.propTypes = {
  projectName: PropTypes.string.isRequired,
  location: PropTypes.string.isRequired,
  workCommitment: PropTypes.number.isRequired,
  areaOfExpertises: PropTypes.arrayOf(PropTypes.string),
  tags: PropTypes.arrayOf(PropTypes.string),
  jobTitles: PropTypes.string,
  description: PropTypes.string.isRequired,
  responsibilities: PropTypes.arrayOf(PropTypes.string).isRequired,
  duration: PropTypes.string.isRequired,
  workLocation: PropTypes.string.isRequired,
  shortOfficeLocation: PropTypes.string.isRequired,
  startDate: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.instanceOf(Date),
  ]),
  buttonStyles: PropTypes.string,
};

ProjectNameSummaryModal.defaultProps = {
  areaOfExpertises: [],
  tags: [],
  jobTitles: '',
  startDate: null,
  buttonStyles: null,
};

export default ProjectNameSummaryModal;
